export default __webpack_public_path__ + "static/9-4045963e6018c4007edd896f644e387c.jpg";